export default __webpack_public_path__ + "static/media/G0535.34I-29298_-16972_0.1654019700000.d1d79d62.jpg";